import React from "react"
import { Link } from "gatsby"

import Layout from "../../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import SEO from "../../components/seo"
import { graphql } from "gatsby"

import Line from "../../images/line.svg"

const BlogList = (props) => {
  return (
    <ul className="list-ul">
      {props.blog.map((blog) => {
        return (
          <li className="blog">
            <div className="reise-card">
              <Link to={"blog/" + blog.slug} className="reise-thumbnail">
                <GatsbyImage image={blog.heroImage.gatsbyImageData} />
              </Link>

              <div className="reise-card-text">
                <h2>{blog.title}</h2>
                <div className="kurzbeschreibung">
                  {blog.body.childMarkdownRemark.excerpt}
                </div>
                <div
                  style={{
                    textAlign: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  className="buchen-button-big-list"
                >
                  <Link to={blog.slug} className="buchen-button-big-link">
                    Weiterlesen
                  </Link>
                </div>
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

const BlogPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="Blog" />
      <div className="reisen-liste-headline">
        <h1>Blog</h1>
        <img className="line" src={Line}></img>
      </div>
      <div className="reisen-liste-container">
        <BlogList blog={data.blog.nodes} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    blog: allContentfulBlogPost(sort: { fields: updatedAt, order: DESC }) {
      nodes {
        title
        slug
        body {
          childMarkdownRemark {
            excerpt(pruneLength: 300)
          }
        }
        heroImage {
          gatsbyImageData(width: 735, layout: CONSTRAINED)
        }
      }
    }
  }
`

export default BlogPage
